<template>
  <div class="mx-auto mt-6 file-input-width">
    <v-card>
      <v-data-table
        v-model="wsService.selectedWs"
        :items="wsService.wsTemplate.ws_layers"
        :headers="headers"
        :single-select="false"
        item-key="name"
        show-select
        class="elevation-0 pa-5"
        dense
      >
        <template v-slot:[`item.styles`]="{ item }">
          <v-select
            v-model="item.layer_style"
            :items="item.styles"
            placeholder="Style"
            :hint="item.defaultStyle"
            hide-details
            class="mt-5"
            solo
            dense
          />
          <small class="text--disabled">
            Default: <b>{{ item.defaultStyle }}</b>
          </small>
        </template>

        <template v-slot:[`item.opacity`]="{ item }">
          <v-select
            v-model="item.layer_opacity"
            :items="opacityOptions"
            item-text="text"
            item-value="value"
            placeholder="Opacity"
            hide-details
            class="mt-5"
            solo
            dense
            :clearable="item.layer_opacity !== null"
            @click:clear="item.layer_opacity = null"
          />
          <small class="text--disabled">
            Default: <b>{{ item.defaultOpacity }}</b>
          </small>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      headers: [],
      customHeaders: [
        {
          text: 'Styles',
          value: 'styles',
          align: 'start',
          sortable: false
        },
        {
          text: 'Opacity',
          value: 'opacity',
          align: 'center',
          sortable: false
        }
      ],
      opacityOptions: [
        { text: 'Default', value: null },
        ...Array.from({ length: 20 }, (_, i) => {
          const v = (i + 1) * 5;

          return { text: v.toString(), value: v };
        })
      ]
    };
  },
  computed: {
    ...mapState(['wsService', 'geoserver_data'])
  },
  async mounted() {
    this.headers = this.geoserver_data.layerHeaders
      .concat(this.customHeaders)
      .filter(item => item.value !== 'actions');
  }
};
</script>
